<template>
    <div class="a-form-inputs p-compare-reserve">
        <h2 class="u-centre chart">Difference between {{fromLabel}} and {{toLabel}}</h2>
        <range-chart :claims="claims" :range="range" v-if="theCurrentWidth >= 600"></range-chart>
    </div>
</template>


<script>

    import {mapGetters} from 'vuex';
    import RangeChart from "./RangeChart";


    const labels = {
        "dayOne": 'Day One Reserve ',
        "paid": 'Paid',
        "final": 'Final Reserve',
        "initial": 'Initial Reserve',
    };

    export default {
        components: {RangeChart},
        name: 'range-chart-container',
        computed: {
            ...mapGetters('reserves/compare', ['claims', 'from', 'to', 'range']),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            fromLabel() {
                return labels[this.from];
            },
            toLabel() {
                return labels[this.to];
            },
        }
    }
</script>


// WEBPACK FOOTER //
// RangeChartContainer.vue?97c00626